<template>
    <div class="p-10" data-uid="last-mile-root-actions">
      <div v-if="orderOfLocations.length">
        <div class="last-mile-timeline-item" v-for="(entry, index) in orderOfLocations" :key="index">
          <div style="z-index: 100;">
            <svgicon :name="entry.entity_type === lastMileEntityTypes.PICKUP ? 'pick-up-arrow' : 'drop-off-arrow'" width="14" height="14" :original="true" />
          </div>
          <div v-if="index < orderOfLocations.length - 1" class="line"></div>
          <Collapse accordian class="collapse-no-bg mx-15" v-model="activeCollapseItemId">
            <collapse-item :name="index" >
              <template slot="title">
                <span class="mr-5">{{ getEntityDisplayName(entry) }}</span>
                <div v-if="entry.collection_amount" class="text-xs status" :class="getClass(entry)">
                  {{ $t('CASH_ON_DELIVERY') }} :
                  <svgicon :name="getSvgIconIndent(entry)" width="10" height="10" :original="true" />
                  <strong class="text-bold">{{$getIndianFormat(entry.collection_amount)}}</strong>
                </div>
                <span class="ml-10" style="margin-bottom: 2px;" v-if="isActionCompleted(entry)">
                  <svgicon name="green-circle-tick" width="14" height="14" :original="true" />
                </span>
                <span v-else-if="isNotDelivered(entry)" class="ml-10" style="margin-bottom: 2px;">
                  <svgicon name="red-circle-x-mark" width="14" height="14" :original="true" />
                </span>
                <span v-else-if="!canPerformAction(entry, index)" class="ml-10" style="margin-bottom: 2px;">
                  <Tooltip :open-delay="200" effect="dark" placement="bottom-start">
                    <div slot="content">{{ actionErrorMessage(entry) }}</div>
                    <svgicon name="icon-info-circle" width="14" height="14" :original="true" />
                  </Tooltip>
                </span>
              </template>
              <last-mile-pickup
              v-if="entry.entity_type === lastMileEntityTypes.PICKUP"
              :order="order"
              :datePickerFormat="datePickerFormat"
              :getBackDateConfig="getBackDateConfig"
              :isTruckInBackDateAllowed="isTruckInBackDateAllowed"
              :isVendorDepotUser="isVendorDepotUser"
              :vendorDepotList="vendorDepotList"
              :vendorDepots="vendorDepots"
              :currentPickup="entry"
              :currentIndex="index"
              :canPerformAction="canPerformAction(entry, index)"
              :isShipper="isShipper"
              :currentUser="currentUser"
              :getEntityDisplayName="getEntityDisplayName"
              :isDatesChanged="isDatesChanged"
              :getFormattedDate="getFormattedDate"
              :isLoadingAtSourceEnabled="isLoadingAtSourceEnabled"
              :isMaterialInvoiceBeforeTruckOut ="isMaterialInvoiceBeforeTruckOut"
              :isLRforTruckOut="isLRforTruckOut"
              v-on="$listeners"
              @cancel="cancel"
              />
              <last-mile-drop
              v-else
              :currentDropoff="entry"
              :order="order"
              :movement="order.movement"
              :datePickerFormat="datePickerFormat"
              :getBackDateConfig="getBackDateConfig"
              :currentIndex="index"
              :canPerformAction="canPerformAction(entry, index)"
              :isShipper="isShipper"
              :configurations="configurations"
              :isLrMandatoryForMarkAsDelivered="isLrMandatoryForMarkAsDelivered"
              :getEntityDisplayName="getEntityDisplayName"
              :isDatesChanged="isDatesChanged"
              :getFormattedDate="getFormattedDate"
              :completedPickupsMap="completedPickupsMap"
              :yetToBeDeliveredDestinationIds="yetToBeDeliveredDestinationIds"
              v-on="$listeners"
              @cancel="cancel"
              />
            </collapse-item>
          </Collapse>
        </div>
      </div>
      <div v-else>{{ $t('NO_PICKUPS_DROPS') }}</div>
    </div>
</template>

<script>
import LastMilePickup from '../../../shipper/src/components/orders/actions-v2/LastMilePickup';
import { lastMileEntityTypes } from 'pando-constants';
import LastMileDrop from '../../../shipper/src/components/orders/actions-v2/LastMileDrop';
import moment from 'moment';

export default {
  name: 'LastMileActions',
  components: {
    LastMilePickup,
    LastMileDrop,
  },
  props: {
    order: {
      type: Object,
      default: () => ({})
    },
    getBackDateConfig: {
      type: Object,
      default: () => ({}),
    },
    isTruckInBackDateAllowed: {
      type: Boolean,
      default: () => false,
    },
    datePickerFormat: {
      type: String,
      default: () => 'dd-MM-yyyy hh:mmA',
    },
    isVendorDepotUser: {
      type: Boolean,
      default: () => false,
    },
    vendorDepots: {
      type: Array,
      default: () => [],
    },
    vendorDepotList: {
      type: Array,
      default: () => [],
    },
    isEligibleForPtlGrouping: {
      type: Boolean,
      default: () => false,
    },
    isShipper: {
      type: Boolean,
      default: () => true
    },
    configurations: {
      type: Object,
      default: () => ({}),
    },
    currentUser: {
      type: Object,
      default: () => ({}),
    },
    isLrMandatoryForMarkAsDelivered: {
      type: Object,
      default: () => ({}),
    },
    isLoadingAtSourceEnabled: {
      type: Boolean,
      default: () => true
    },
    isMaterialInvoiceBeforeTruckOut: {
      type: Boolean,
      default: () => false
    },
    isLRforTruckOut: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      lastMileEntityTypes,
      orderOfLocations: [],
      activeCollapseItemId: [0],
      incompletePickupOrDropoffIndex: -1,
      completedPickupsMap: {},
    };
  },
  created() {
    this.orderOfLocations = this.getOrderOfLocations;
    this.incompletePickupOrDropoffIndex = this.getIncompletePickupOrDropoffIndex;
    this.completedPickupsMap = this.getCompletedPickupsMap;
  },
  computed: {
    yetToBeDeliveredDestinationIds() {
      return this.order.destinations.reduce((acc, dest) => {
        if (!dest.release_at) {
          const destId = (this.isShipper ? dest.unique_id : dest._id).toString();
          acc.push(destId);
        }
        return acc;
      }, []);
    },
    getOrderOfLocations() {
      const result = [];
      let s = 0;
      let d = 0;
      const sources = this.order.sources;
      const destinations = this.order.destinations;
      // merge two sorted arrays
      while(s < sources.length && d < destinations.length) {
        if (sources[s].sequence_number < destinations[d].sequence_number) {
          result.push(sources[s]);
          s += 1;
        } else {
          result.push(destinations[d]);
          d += 1;
        }
      }
      // not iterating sources because end sequence number will always be a destination
      while(d < destinations.length) {
        result.push(destinations[d]);
        d += 1;
      }
      return result;
    },
    getIncompletePickupOrDropoffIndex() {
      for (let i = 0; i < this.orderOfLocations.length; i += 1) {
        const entity = this.orderOfLocations[i];
        const isPickupIncomplete = entity.entity_type === lastMileEntityTypes.PICKUP && entity.arrived_at && !entity.dispatched_at;
        const isDropIncomplete = entity.entity_type === lastMileEntityTypes.DROPOFF && entity.reported_at && !entity.release_at;
        if (isPickupIncomplete || isDropIncomplete) return i;
      }
      return -1;
    },
    getCompletedPickupsMap() {
      return this.orderOfLocations.reduce((acc, entity) => {
        if (entity.entity_type == lastMileEntityTypes.PICKUP && entity.dispatched_at) {
          acc[`${entity.location_id}_${entity.gate_id || ''}`] = true;
        }
        return acc;
      }, {});
    },
  },
  methods: {
    getSvgIconIndent(destination) {
      return destination.is_cash_collected ? 'rupee' : 'rupee-error';
    },
    getClass(destination) {
      return destination.is_cash_collected ? 'status-green' : 'status-red';
    },
    getFormattedDate(date) {
      const timeFormat = this.configurations.is_datepicker_24H_enabled ? 'Do MMMM YYYY - HH:mm'
        : 'Do MMMM YYYY - hh:mm a';
      return moment(date).format(timeFormat);
    },
    isDatesChanged(date1, date2) {
      const momentDate1 = moment(date1 || null);
      const momentDate2 = moment(date2 || null);
      let isValid = false;
      if (momentDate1.isValid() && momentDate2.isValid()) {
        isValid = momentDate1.diff(momentDate2) !== 0;
      } else if (momentDate1.isValid() !== momentDate2.isValid()) {
        isValid = true;
      }
      return isValid;
    },
    actionErrorMessage(entry) {
      if (entry.entity_type === lastMileEntityTypes.DROPOFF &&
        !this.completedPickupsMap[`${entry.source_location_id}_${entry.source_gate_id || ''}`]) {
        return this.$t('COMPLETE_PREVIOUS_PICKUP');
      }
      return this.$t('COMPLETE_PREVIOUS_TASKS');
    },
    canPerformAction(entry, index) {
      if (entry.entity_type === lastMileEntityTypes.PICKUP) {
        return this.canPerformActionForPickup(index);
      }
      return this.canPerformActionForDropoff(entry, index);
    },
    canPerformActionForPickup(index) {
      return this.incompletePickupOrDropoffIndex === -1 || this.incompletePickupOrDropoffIndex === index;
    },
    canPerformActionForDropoff(entry, index) {
      const isPickupCompleted = !!this.completedPickupsMap[`${entry.source_location_id}_${entry.source_gate_id || ''}`]
      return (this.incompletePickupOrDropoffIndex === -1 || this.incompletePickupOrDropoffIndex === index) &&
        isPickupCompleted;
    },
    getEntityDisplayName(entry) {
      let dropName = '';
      let gateName = '';
      let gate = null;
      if (this.isShipper) {
        dropName = entry.details.name;
        gate = entry.gate_id ?
          this.$depot.gate(entry.gate_id, entry.location_id) : null;
      } else {
        dropName = entry.address.name;
        gate = entry.gate_id ?
          entry.address.gates.find(_gate => _gate._id === entry.gate_id) : null;
      }
      gateName = gate ? gate.name : '';
      return gateName ? `${gateName} - ${dropName}` : dropName;
    },
    isNotDelivered(entry) {
      return entry.entity_type === this.lastMileEntityTypes.DROPOFF && entry.is_not_delivered;
    },
    isActionCompleted(entry) {
      return (entry.entity_type === this.lastMileEntityTypes.PICKUP && entry.dispatched_at) ||
        (entry.entity_type === this.lastMileEntityTypes.DROPOFF && !entry.is_not_delivered && entry.release_at);
    },
    cancel() {
      this.activeCollapseItemId = [];
    },
  },
  watch: {
    activeCollapseItemId(newValue) {
      if (newValue.length === 2) {
        this.activeCollapseItemId.splice(0, 1);
      }
    }
  }
};
</script>

<style lang="scss">
div[data-uid='last-mile-root-actions'] {
    display: flex;
    flex-direction: column;
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    .last-mile-timeline-item {
      position: relative;
      display: flex;
      .dot, .dot1 {
        width: 19px;
        height: 18px;
        border-radius: 50%;
        position: relative;
        z-index: 100;
        .arrow-tl, .arrow-br {
          font-size: 13px;
          font-weight: bold;
          position: absolute;
          top: 1px;
          color: white;
          left: 3px;
        }
      }
      .dot {
        background-color: #63C1F8;
      }
      .dot1 {
        background-color: #0076DD;
        .arrow-br {
          top: 0px;
        }
      }
      .line {
        width: 2px;
        flex-grow: 1;
        position: absolute;
        top: 8px;
        bottom: 0;
        left: 7px;
        border-left: 1px dashed #8A8A9E50;
        z-index: 1;
      }
      .content {
        padding: 0 10px 10px;
        border-radius: 5px;
        &-header {
          color: #8A8A9E;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: 5px;
        }
        &-sub-header {
          color: #D5DAF4;
          font-weight: 700;
          font-size: 12px;
          .sub-content {
            position: relative;
            left: 170px;
            top: -13px;
            font-size: 10px;
            font-weight: 400;
            color: #8A8A9E;
          }
        }
      }
    }

  .last-mile-flex-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    /* width: 500px; */
    background-color: rgb(238, 238, 238);
    .last-mile-row {
      display: flex;
      justify-content: space-between;
      /* margin-bottom: 10px; */
      .last-mile-span {
        flex-basis: 50%;
        padding: 5px;
      }
    }
  }
  .el-collapse {
    width: 100%;
    border-top: 0px;
    border-bottom: 0px;
    &-item__arrow {
      &:before {
        display: none;
      }
    }
    &-item__header {
      border: none !important;
      top: -8px;
      height: 40px !important;
      background-color: transparent;
    }
    &-item__content {
      line-height: 2.1 !important;
    }
    &-item__arrow {
      display: none;
    }
    // &-item__wrap {
    //   min-height: 150px;
    // }
    &.collapse-no-bg {
          border: none;
          .el-collapse {
              &-item {
                  margin-top: 5px;
                  &.is-active {
                      .el-collapse-item {
                          &__header {
                              background-color: transparent;
                              border-left: none;
                          }
                      }
                  }
                  &__header {
                      height: 35px;
                      padding: 0 10px 10px 25px;
                      position: relative;
                      font: 1.2rem/17px 'OpenSans-Semibold';
                      color: #234357;
                      text-transform: uppercase;
                      border-left: 1px solid #D6D6D6;
                      &:after {
                          content: '';
                          width: 2px;
                          height: 35px;
                          position: absolute;
                          top: -1px;
                          left: 0;
                      }
                      .icon-title {
                          margin: 0 5px;
                      }
                      .status-title {
                          position: absolute;
                          right: 50px;
                          line-height: 12px;
                      }
                      &:hover {
                          background-color: #EFEFEF;
                      }
                  }
                  &__wrap {
                      border-bottom: none;
                  }
                  &__content {
                      padding: 10px 15px;
                  }
              }
          }
      }
  }

}
</style>
